import React from "react";
import { Toggle } from "@amzn/awsui-components-react";

export interface HideAllPassingToggleProps {
  readonly on: boolean;
  readonly onChange: (next: boolean) => void;
}

export const HideAllPassingToggle: React.FC<HideAllPassingToggleProps> = ({
  on,
  onChange,
}) => (
  <Toggle checked={on} onChange={({ detail }) => onChange(detail.checked)}>
    Hide all-passing steps
  </Toggle>
);
